/**
 * @info you can debug this locally by visiting url/to/your/ngrok?forceGtm=true from google tag manager preview.
 */
export default function ({ gtmCode }: { gtmCode?: string } = {}) {
  /**
   * This composable should only run in the client context
   * Therefore, early return when it runs in the server context
   */
  if (import.meta.server) return;

  const config = useRuntimeConfig();
  const gtmId = gtmCode || config.public.GTM || 'GTM-W9WWJW';
  const isProduction = config.public.STAGE === 'production';
  const route = useRoute();
  const scriptBaseUrl = `${config.app.baseURL === '/' ? '' : config.app.baseURL}`;

  const enableGtm = route.query.forceGtm === 'true' || route.query.gtm === 'true';
  const disableGtm = route.query.gtm === 'false' || isStoryblokPreview();

  // if not production and not forced, do not load GTM
  if (!isProduction && !enableGtm) return;

  // if disabled via query param, do not load GTM
  if (disableGtm) return;

  // if crawler and GTM is not enabled via query param, do not load GTM
  if (checkIsCrawler(useRequestHeader('user-agent') ?? '') && !enableGtm) return;

  onMounted(() => {
    injectGtm();
  });

  function injectGtm() {
    if (document.getElementById('gtm-init')) return;

    const script = document.createElement('script');
    script.id = 'gtm-init';
    script.async = true;
    script.defer = true;
    script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    '${scriptBaseUrl}/misc/ptm?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
  }
}
